import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Typography from 'components/atoms/Typography'
import NumberedListItem from 'components/molecules/NumberedListItem'

import { string, arrayOf } from 'prop-types'

const MajorWhy = ({ title, subtitle, reasons }) => (
  <div id="benefits" className="major-why">
    <SectionContainer
      marginTop={120}
    >
      <Container>
        <Row>
          <Col md="4">
            <SectionTitle title={title} align="left" />
          </Col>
          <Col md="8">
            <Typography component="p" variant="body" className="major-why__subtitle">
              { subtitle }
            </Typography>
            <div className="major-why__reasons">
              {
                reasons.map((reason, idx) => (
                  <NumberedListItem key={`why-major-${idx}`} no={idx + 1} content={reason}/>
                ))
              }
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .highlight {
          color: #0fc3c4;
        }
        .major-why {
          &__reasons {
            margin-top: 32px;
          }
          :global(.number-list-item) {
            margin-left: 24px;
          }
        }
      `}
    </style>
  </div>
)

MajorWhy.propTypes = {
  title: string,
  subtitle: string,
  reasons: arrayOf(string),
}

export default MajorWhy
